import React, { useState, useRef, useEffect } from "react";
import FileItem from "./file-item";
import ContextMenu from "./context-menu";
import "./file-browser.css";

function FileBrowser({ files, isCutting, canPaste, onDoubleClickFileItem, onClickFileItem, onContextMenuClicked, isSharedFolder }) {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [lastSelectedFile, setLastSelectedFile] = useState(null);
    const [contextMenuPosition, setContextMenuPosition] = useState({ left: 0, top: 0 });
    const [contextMenuFile, setContextMenuFile] = useState(null);
    const [hasTarget, setHasTarget] = useState(null);
    const contextMenuRef = useRef(null);
    const fileBrowserRef = useRef(null);

    useEffect(() => {
        const appElement = document.querySelector('.file-manager__body-files');
        appElement.addEventListener("click", handleDocumentClick);
        return () => {
            appElement.removeEventListener("click", handleDocumentClick);
        };
    }, [contextMenuVisible]);


    const handleDocumentClick = (event) => {
        event.preventDefault();

        if(event.target.closest('.file-item')) {
            return;
        }

        if (contextMenuVisible && !contextMenuRef.current.contains(event.target)) {
            setContextMenuVisible(false);
            setSelectedFiles([]);
            return;
        }
        
        if (!contextMenuVisible && !canPaste) {
           handleClickFileItem({}, event);
        }
    };

    /**
     * Método responsável por seleção ficheiros. Seleção simples, ou seleção múltipla através de CTR+Click ou SHIFT+Click
     */
    const handleClickFileItem = (file, event) => {
        if(contextMenuVisible) {
            setContextMenuVisible(false);
        }

        let newSelectedFiles = file?.alias ? [file] : [];
        let isMultSelection = false;

        // handle CTRL + click 
        if (event.metaKey) {
            onMultiClickFile(file);
            return
        }

        // handle SHIF + click
        if (event.shiftKey && lastSelectedFile?.alias) {
            // Obter índice do último item selecionado e do item atual
            const lastIndex = files.indexOf(lastSelectedFile);
            const currentIndex = files.indexOf(file);

            // Verificar qual intervalo selecionar
            const [start, end] = lastIndex < currentIndex ? [lastIndex, currentIndex] : [currentIndex, lastIndex];

            // Selecionar todos os arquivos entre os dois índices
            newSelectedFiles = files.slice(start, end + 1);
            isMultSelection = true;
        }
        
        setLastSelectedFile(file);
        setSelectedFiles(newSelectedFiles);
        onClickFileItem(newSelectedFiles, isMultSelection);
    };

    const handleDoubleClickFileItem = (file) => {
        onDoubleClickFileItem(file);
    };

    /**
     * Método responsável por abrir o context menu
     */
    const handleContextMenuOpen = (event) => {
        event.preventDefault();
        const { clientX, clientY } = event;
        setContextMenuPosition({ left: clientX, top: clientY });
        setHasTarget(false);

        if (event.target.dataset.alias) {
            setHasTarget(true);
            const contextMenuFile = (files ?? []).find((item) => item.alias === event.target.dataset.alias);
            setContextMenuFile(contextMenuFile);

            if (selectedFiles.length <= 1) {
                handleClickFileItem(contextMenuFile, event);
            } else if(!selectedFiles.includes(contextMenuFile)) {
                
                onMultiClickFile(contextMenuFile);
            }
        } else if(!canPaste) {
            handleClickFileItem([], event);
        }
        setContextMenuVisible(true);
    };

    const handleContextMenuClick = (event, option) => {
        event.stopPropagation();
        onContextMenuClicked(option, contextMenuFile);
        setContextMenuVisible(false);
    };

    const onMultiClickFile = (file) => {
        const updatedSelectedFiles = selectedFiles.includes(file)
            ? selectedFiles.filter((selectedFile) => selectedFile !== file)
            : [...selectedFiles, file];

        setContextMenuVisible(false);
        setSelectedFiles(updatedSelectedFiles);
        onClickFileItem(updatedSelectedFiles, true);
    }

    return (
        <div
            className="file-manager__body-files__table"
            ref={fileBrowserRef}
            onContextMenu={(event) => handleContextMenuOpen(event)}
        >
            <div className="file-browser">
                {files.length > 0 ? (
                    files.map((file) => (
                        <FileItem
                            key={`${file.alias}-file-item`}
                            file={file}
                            isCutting={isCutting}
                            onDoubleClick={() => handleDoubleClickFileItem(file)}
                            onClickFile={(e) => handleClickFileItem(file, e)}
                            onMultiSelectionClicked={onMultiClickFile}
                            selectedFiles={selectedFiles}
                        />
                    ))
                ) : (
                    <p>{__('files_empty_folder')}</p>
                )}

                {contextMenuVisible && (
                    <div  ref={contextMenuRef}>
                        <ContextMenu
                            hasTarget={hasTarget}
                            isSharedFolder={isSharedFolder}
                            contextMenuPosition={contextMenuPosition}
                            canPaste={canPaste}
                            selectedFiles={selectedFiles}
                            onItemClicked={handleContextMenuClick}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default FileBrowser;
